module.exports = __webpack_public_path__ + "static/media/BentonSansCond-RegItalic.69a4217c.otf";